define((require) => {
    "use strict";

    const ImprovedModel       = require("shared/zbone/ImprovedModel");
    const Preconditions       = require("shared/util/Preconditions");
    const GroupAssetReference = require("shared/ui/groups/GroupAssetReference");
    const GroupsDescriptor    = require("shared/data/groups/GroupsDescriptor");

    /**
     * @private @type {Map.<Function, String>}
     */
    const valueTypes = GroupsDescriptor.valueTypes;

    /**
     * Represents the internal data structure for an asset in a <tt>GroupModel</tt>, the actual *asset* is referenced via the <tt>value</tt> field.
     *
     * @class GroupAsset
     * @constructor
     */
    const GroupAsset = ImprovedModel.extend("Group Asset", {

        defaults: {

            /**
             * The type of value, e.g. <tt>Breakpoint</tt>.
             *
             * @type {String}
             */
            type: null,

            /**
             * A group specific value (e.g. Breakpoint).
             *
             * @type {Backbone.Model}
             */
            value: null,

            /**
             * The actual asset, e.g. <tt>ExperienceModel</tt>.
             *
             * @type {*}
             */
            asset: null,

            /**
             * @deprecated Deprecated in favor of <tt>asset</tt>.
             *
             * A reference to the asset in question, as an object containing <tt>resourceId</tt> and <tt>resourceType</tt>
             * resourceId could be experience id, image id etc and resourceType could be "Experience", "Image".
             *
             * <pre>
             * "reference": {
             *      "resourceId": null,
             *      "resourceType": null
             * }
             * </pre>
             *
             * @type {Object}
             */
            reference: null
        },

        transient: ["asset"]

    }, {

        validValue(asset) {
            return asset && valueTypes.has(asset.constructor);
        },

        typeFromValue(value) {
            Preconditions.checkState(GroupAsset.validValue(value), `Invalid value: ${value}`);

            return GroupAsset.typeFromValueClass(value.constructor);
        },

        typeFromValueClass(constructorFunction) {
            return valueTypes.get(constructorFunction);
        },

        /**
         * Factory method for creating the internal asset from the specified asset and associated value.
         *
         * @param  {*} asset The asset, e.g. a <tt>ExperienceModel</tt> instance.
         * @param  {*} value The value, e.g. an <tt>Breakpoint</tt> instance.
         * @param  {String} valueType The type of value, e.g. <tt>Breakpoint</tt>.
         *
         * @return {GroupAsset} A new <tt>GroupAsset</tt> instance, to be added to the <tt>GroupAssetCollection</tt>.
         */
        asAsset(asset, value, valueType) {
            const body = {
                asset,
                type: valueType,
                reference: asset instanceof ImprovedModel ? GroupAssetReference.toJSON(asset) : asset
            };

            // Add optional value if present...
            if (value) {
                body.value = value;
            }

            return new GroupAsset(body);
        }

    });

    return GroupAsset;
});



// WEBPACK FOOTER //
// ./src/shared/ui/groups/GroupAsset.js